/**
 * data/quests — the authored quest content (owner decision D17).
 *
 * Read-only at runtime. The save stores only per-quest PROGRESS (QuestState);
 * these defs can be edited/extended without a migration. Aggregates the main
 * spine (main-badge-1..8 + main-finale), the 10 tavern side quests, and the 8
 * gym leaders. The pure engine (core/quests.ts) folds play events into progress.
 */
import type { QuestDef } from '@/shared';
import { MAIN_QUESTS } from './main.js';
import { SIDE_QUESTS } from './side.js';
import { RIVAL_QUESTS } from './rival.js';

export { MAIN_QUESTS } from './main.js';
export { SIDE_QUESTS } from './side.js';
export { RIVAL_QUESTS, RIVAL_ROLE } from './rival.js';
export { GYM_LEADERS, gymLeaderById } from './leaders.js';
export type { GymLeader } from './leaders.js';

/** Every authored quest (main spine + side + rival chain), for the engine + offer scan. */
export const ALL_QUESTS: readonly QuestDef[] = [...MAIN_QUESTS, ...SIDE_QUESTS, ...RIVAL_QUESTS];

/** O(1) lookup of any quest def by id. */
const QUEST_BY_ID = new Map(ALL_QUESTS.map((q) => [q.id, q]));

export function questById(id: string): QuestDef | undefined {
  return QUEST_BY_ID.get(id);
}
